import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { vnmStatuses } from 'domain/vnm';

interface Props {
  planId?: number;
}
export const useVnmSubscriptionStatus = ({ planId }: Props) => {
  const { data, loading, error, refetch } = useQuery<
    GetVnmSubscriptionStatusQuery,
    GetVnmSubscriptionStatusQueryVariables
  >(GET_VNM_SUBSCRIPTION_STATUS, {
    skip: !planId,
    variables: { planId: planId || -1 },
  });
  const subscription = data?.plan.vnmProductSubscription?.vnmSubscription;
  let status = subscription?.status;

  // For enrolled users on a pre-live project, show them the waitlist state
  const projectStartDate = new Date(subscription?.vnmSolarProject?.startDate);
  const projectLive = projectStartDate <= new Date();
  if (!projectLive && status === vnmStatuses.enrolled)
    status = vnmStatuses.waitlist;

  return {
    data: { status, subscription },
    error,
    loading,
    refetch,
  };
};

export const GET_VNM_SUBSCRIPTION_STATUS = gql`
  query GetVnmSubscriptionStatus($planId: Int!) {
    plan(id: $planId) {
      id
      vnmProductSubscription {
        id
        vnmSubscription {
          id
          status
          vnmSolarProject {
            id
            name
            startDate
          }
        }
      }
    }
  }
`;

export const getVnmSubscriptionStatusMock = {
  plan: {
    id: 20,
    vnmProductSubscription: {
      id: 3,
      vnmSubscription: {
        id: 4,
        status: 'billed',
        vnmSolarProject: {
          id: 6,
          name: 'Fake 1',
          startDate: '2020-01-01',
        },
      },
    },
  },
};

export const getVnmSubscriptionStatusMockPreLive = {
  plan: {
    id: 20,
    vnmProductSubscription: {
      id: 3,
      vnmSubscription: {
        id: 4,
        status: 'enrolled',
        vnmSolarProject: {
          id: 6,
          name: 'Fake 2',
          startDate: '3000-01-01',
        },
      },
    },
  },
};

const subscription =
  getVnmSubscriptionStatusMock.plan.vnmProductSubscription.vnmSubscription;
export const useVnmSubscriptionStatusMock = {
  data: {
    status: subscription.status,
    subscription,
  },
  error: undefined,
  loading: false,
  refetch: () => null,
};
